module.exports = __webpack_public_path__ + "img/banner.34539782.png";